module.exports = __webpack_public_path__ + "img/vouchers202.b997c5bc.png";